import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, Transition as _Transition, createBlock as _createBlock } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "top-[3px] ltr:right-[4px] rtl:left-[4px] w-[6px] h-[6px] rounded-full absolute bg-orange-500"
}
const _hoisted_2 = { class: "flex items-center justify-between px-[20px] pb-[17px]" }
const _hoisted_3 = { class: "font-semibold text-black dark:text-white text-[15px]" }
const _hoisted_4 = { class: "text-gray-500 dark:text-gray-400 font-normal text-base" }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = {
  key: 0,
  class: "flex justify-center py-4"
}
const _hoisted_7 = {
  key: 1,
  class: "text-center py-4 text-danger-500"
}
const _hoisted_8 = {
  key: 2,
  class: "text-center py-4 text-gray-500"
}
const _hoisted_9 = {
  key: 3,
  class: "mb-[18px]"
}
const _hoisted_10 = { class: "rounded-full flex items-center justify-center absolute text-center transition-all top-1/2 -translate-y-1/2 ltr:left-[20px] rtl:right-[20px] w-[44px] h-[44px] text-primary-500 bg-[#4936f50d]" }
const _hoisted_11 = { class: "material-symbols-outlined !text-[22px]" }
const _hoisted_12 = { class: "block mb-[3px] text-black dark:text-white" }
const _hoisted_13 = { class: "block text-sm text-gray-500" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = {
  key: 0,
  class: "inline-block rounded-full bg-primary-500 absolute w-[6px] h-[6px] right-[20px] top-1/2 -translate-y-1/2"
}
const _hoisted_16 = { class: "text-center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_MenuButton = _resolveComponent("MenuButton")!
  const _component_RouterLink = _resolveComponent("RouterLink")!
  const _component_MenuItems = _resolveComponent("MenuItems")!
  const _component_Menu = _resolveComponent("Menu")!

  return (_openBlock(), _createBlock(_component_Menu, {
    as: "div",
    class: "relative notifications-menu mx-[8px] md:mx-[10px] lg:mx-[12px] ltr:first:ml-0 ltr:last:mr-0 rtl:first:mr-0 rtl:last:ml-0"
  }, {
    default: _withCtx(({ close }) => [
      _createVNode(_component_MenuButton, { class: "leading-none inline-block transition-all relative top-[2px] hover:text-primary-500" }, {
        default: _withCtx(() => [
          _cache[0] || (_cache[0] = _createElementVNode("i", { class: "material-symbols-outlined !text-[22px] md:!text-[24px]" }, " notifications ", -1)),
          (_ctx.unreadCount > 0)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }),
      _createVNode(_Transition, {
        "enter-active-class": "transition ease-out duration-100",
        "enter-from-class": "transform opacity-0 scale-95",
        "enter-to-class": "transform opacity-100 scale-100",
        "leave-active-class": "transition ease-in duration-75",
        "leave-from-class": "transform opacity-100 scale-100",
        "leave-to-class": "transform opacity-0 scale-95"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_MenuItems, { class: "bg-white dark:bg-[#0c1427] transition-all shadow-3xl dark:shadow-none py-[17px] absolute mt-[17px] md:mt-[20px] w-[290px] md:w-[350px] z-[1] top-full ltr:-right-[120px] ltr:md:right-0 rtl:-left-[120px] rtl:md:left-0 rounded-md focus:outline-hidden" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("span", _hoisted_3, [
                  _createTextVNode(_toDisplayString(_ctx.directT('navbar.notifications')) + " ", 1),
                  _createElementVNode("span", _hoisted_4, " (" + _toDisplayString(_ctx.unreadCount) + ") ", 1)
                ]),
                _createElementVNode("a", {
                  href: "javascript:void(0);",
                  onClick: ($event: any) => {_ctx.markAllAsRead(); close()},
                  class: "text-primary-500"
                }, _toDisplayString(_ctx.directT('navbar.clearAll')), 9, _hoisted_5)
              ]),
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[1] || (_cache[1] = [
                    _createElementVNode("div", { class: "inline-block animate-spin rounded-full border-4 border-primary-500 border-t-transparent h-8 w-8" }, null, -1)
                  ])))
                : (_ctx.error)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_ctx.error), 1))
                  : (_ctx.notifications.length === 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_ctx.directT('navbar.noNotifications')), 1))
                    : (_openBlock(), _createElementBlock("ul", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.notifications, (notification) => {
                          return (_openBlock(), _createElementBlock("li", {
                            key: notification.id,
                            class: "relative border-b border-gray-100 dark:border-[#172036] border-dashed py-[17px] ltr:pl-[75px] ltr:pr-[20px] rtl:pr-[75px] rtl:pl-[20px] first:border-t first:border-gray-100 dark:first:border-[#172036]"
                          }, [
                            _createElementVNode("div", _hoisted_10, [
                              _createElementVNode("i", _hoisted_11, _toDisplayString(_ctx.getNotificationIcon(notification.type)), 1)
                            ]),
                            _createElementVNode("span", _hoisted_12, _toDisplayString(notification.content), 1),
                            _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.formatDate(notification.timestamp)), 1),
                            _createElementVNode("button", {
                              onClick: ($event: any) => {_ctx.markAsRead(notification); close()},
                              class: "block left-0 top-0 right-0 bottom-0 z-[1] absolute"
                            }, null, 8, _hoisted_14),
                            (notification.status === 'unread')
                              ? (_openBlock(), _createElementBlock("span", _hoisted_15))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ])),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(_component_RouterLink, {
                  to: "/notifications",
                  class: "inline-block font-medium relative text-primary-500 transition-all hover:underline",
                  onClick: ($event: any) => (close())
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.directT('navbar.seeAllNotifications')), 1)
                  ]),
                  _: 2
                }, 1032, ["onClick"])
              ])
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024)
    ]),
    _: 1
  }))
}